"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var actions_1 = require("../../redux/reducers/lotto-unclaimed-prizes/actions");
var framework_1 = require("../../widgets/framework");
var styles_1 = require("./styles");
var util_1 = require("./util/util");
var TableHeaders = [
    { name: 'Prize', width: 132 },
    { name: 'Date', width: 118 },
    { name: 'Retailer Name', width: 225 },
    { name: 'Retailer Address', width: 225 }
];
var GamesUnclaimedPrizesScreen = function (_a) {
    var _b = _a.gameTypes, gameTypes = _b === void 0 ? [2, 7, 5] : _b;
    var dispatch = (0, react_redux_1.useDispatch)();
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.styles)(theme)();
    var unclaimedPrizes = (0, react_redux_1.useSelector)(function (state) { return state.gameUnclaimedPrizes; });
    var unclaimedPrizesTables = (0, util_1.getUnclaimedPrizeTablesData)(unclaimedPrizes === null || unclaimedPrizes === void 0 ? void 0 : unclaimedPrizes.gameUnclaimedPrizes);
    (0, react_1.useEffect)(function () {
        getUnclaimedPrizes();
    }, []);
    var getUnclaimedPrizes = function () {
        dispatch((0, actions_1.fetchUnclaimedPrizes)(gameTypes));
    };
    var onCheckNumberClicked = function (gameId) {
        var appNavigate = {
            action: 'NUMBER_CHECKER',
            data: { gameId: gameId }
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    var getStyle = function (index) {
        return { minWidth: "".concat(TableHeaders[index].width, "px") };
    };
    if (unclaimedPrizes.loading) {
        return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, style: { minHeight: '400px' } },
            react_1.default.createElement(package_1.AppSpinner, { label: 'Loading Unclaimed Prizes', customStyles: {
                    backgroundColor: 'transparent'
                } })));
    }
    if (unclaimedPrizes.error) {
        return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, style: { minHeight: '400px' } },
            react_1.default.createElement(package_1.LoadError, { onReloadIconPress: getUnclaimedPrizes, text: "Something went wrong while loading the content!" })));
    }
    if (!unclaimedPrizes.loading && unclaimedPrizes.gameUnclaimedPrizes.length === 0) {
        return (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, style: { minHeight: '400px', display: 'flex', justifyContent: 'center' } },
            react_1.default.createElement(core_1.Typography, { variant: 'body1' }, "No unclaimed prizes available.")));
    }
    return (react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12 }, unclaimedPrizesTables &&
            unclaimedPrizesTables.map(function (table) { return (react_1.default.createElement("div", { key: table.key, className: (0, classnames_1.default)(classes.topSpacing) },
                react_1.default.createElement(core_1.Typography, { variant: "h3" }, table.headerName.includes('Print-N-Play') ? 'Print-N-Play' : table.headerName),
                react_1.default.createElement("div", { style: { overflowX: 'auto' }, tabIndex: 0, role: "region", "aria-label": "Unclaimed Prizes Tables" },
                    react_1.default.createElement(core_1.Table, { style: { overflowX: 'scroll' } },
                        react_1.default.createElement(core_1.TableHead, null,
                            react_1.default.createElement(core_1.TableRow, null, TableHeaders.map(function (header, index) { return (react_1.default.createElement(core_1.TableCell, { key: "".concat(index), className: (0, classnames_1.default)(classes.body1High), width: header.width }, header.name)); }))),
                        react_1.default.createElement(core_1.TableBody, null, table.unclaimedPrizeRows.map(function (row, index) { return (react_1.default.createElement(core_1.TableRow, { key: row.key },
                            react_1.default.createElement(core_1.TableCell, { className: (0, classnames_1.default)(classes.body2High), style: getStyle(0) }, row.prize),
                            react_1.default.createElement(core_1.TableCell, { className: (0, classnames_1.default)(classes.body2High), style: getStyle(1) }, row.date),
                            react_1.default.createElement(core_1.TableCell, { className: (0, classnames_1.default)(classes.body2High), style: getStyle(2) }, row.retailerName),
                            react_1.default.createElement(core_1.TableCell, { className: (0, classnames_1.default)(classes.body2High), style: getStyle(3) }, row.retailerAddress))); })))),
                !table.headerName.includes('Print-N-Play') && (react_1.default.createElement(core_1.Grid, { className: (0, classnames_1.default)(classes.alignCenter) },
                    react_1.default.createElement(core_1.Button, { size: "large", variant: "contained", color: "primary", disableElevation: true, onClick: onCheckNumberClicked.bind(_this, (0, util_1.onCheckNumberClickedMap)(table.gameId)) }, "CHECK MY ".concat(table.buttonName, " NUMBERS")))))); }))));
};
exports.default = GamesUnclaimedPrizesScreen;
//# sourceMappingURL=index.js.map